import { useCallback, useEffect, useRef, useState } from 'react';

import { ProductSelection } from './ProductSelection';
import { Svg } from '../../snippets/Svg';

export function ProductDetails({
  enabledQuantitySelector,
  enabledTrustBuilders,
  product,
  productDetailAccordionsSection,
  selectedOptions,
  selectedVariant,
  setSelectedOptions,
  isGiftCard,
  inventory,
  inventoryFetched,
  quantity,
  handleDecrement,
  handleIncrement,
  refElement,
  lowInventoryNotification,
  enabledsizeGuide,
  sizeGuides,
  swatches,
  disableGroupHistory,
  enabledSoldOutColorSwatch,
  isSoldOut,
  soldOutQty,
  enabledGroupTabs,
  enabledGroupTabsLink,
  productTypeForGroupTabs,
  enabledGroupOptions,
  enabledGroupOptionsLink,
  productTypeForGroupOptions,
  needsSelection,
  optionChanges,
  setOptionChanges,
  groupedBreadcrumbs,
}) {
  const descriptionRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const isFinalSale = product.tags.includes('Final Sale');

  const toggleExpansion = useCallback(() => {
    setIsExpanded(!isExpanded);
  }, [isExpanded]);

  useEffect(() => {
    if (descriptionRef.current.clientHeight > 100) {
      setIsExpanded(false);
    } else {
      setIsExpanded(true);
    }
  }, []);

  return (
    <div className="flex flex-col gap-5">
      <ProductSelection
        enabledQuantitySelector={enabledQuantitySelector}
        product={product}
        selectedOptions={selectedOptions}
        selectedVariant={selectedVariant}
        setSelectedOptions={setSelectedOptions}
        isGiftCard={isGiftCard}
        inventory={inventory}
        inventoryFetched={inventoryFetched}
        isSoldOut={isSoldOut}
        quantity={quantity}
        handleDecrement={handleDecrement}
        handleIncrement={handleIncrement}
        refElement={refElement}
        lowInventoryNotification={lowInventoryNotification}
        enabledsizeGuide={enabledsizeGuide}
        sizeGuides={sizeGuides}
        swatches={swatches}
        disableGroupHistory={disableGroupHistory}
        enabledSoldOutColorSwatch={enabledSoldOutColorSwatch}
        soldOutQty={soldOutQty}
        enabledGroupTabs={enabledGroupTabs}
        enabledGroupTabsLink={enabledGroupTabsLink}
        productTypeForGroupTabs={productTypeForGroupTabs}
        enabledGroupOptions={enabledGroupOptions}
        enabledGroupOptionsLink={enabledGroupOptionsLink}
        productTypeForGroupOptions={productTypeForGroupOptions}
        needsSelection={needsSelection}
        optionChanges={optionChanges}
        setOptionChanges={setOptionChanges}
        groupedBreadcrumbs={groupedBreadcrumbs}
      />

      {enabledTrustBuilders && (
        <div className="flex flex-row gap-2.5">
          <div className="w-1/2 flex flex-row items-center gap-2.5">
            <div className="w-auto">
              <Svg
                className="text-text"
                src="/svgs/free-shipping.svg#free-shipping"
                alt="Free Shipping Icon"
                title="Free Shipping"
                viewBox="0 0 48 48"
                width="48px"
                height="48px"
              />
            </div>
            <div>
              <p className="uppercase mb-0">Free Standard Shipping</p>
              <p className="mb-0">On domestic orders $150+</p>
            </div>
          </div>
          {!isFinalSale && (
            <div className="w-1/2 flex flex-row items-center gap-2.5">
              <div className="w-auto">
                <Svg
                  className="text-text"
                  src="/svgs/free-returns.svg#free-returns"
                  alt="Free Returns Icon"
                  title="Free Returns"
                  viewBox="0 0 48 48"
                  width="48px"
                  height="48px"
                />
              </div>
              <div>
                <p className="uppercase mb-0">Free Returns & Exchanges</p>
                <p className="mb-0">30 days after purchase</p>
              </div>
            </div>
          )}
        </div>
      )}
      
      <div className="relative w-full">
        <div ref={descriptionRef}>
          <div className={`overflow-hidden ${isExpanded ? 'h-auto' : 'h-28'}`}>
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: product.descriptionHtml }}
              className="text-base [&>:last-child]:mb-0 [&_a]:underline [&_blockquote]:pl-8 [&_h1]:mb-3 [&_h2]:mb-3 [&_h3]:mb-3 [&_h4]:mb-3 [&_h5]:mb-3 [&_h6]:mb-3 [&_li>p]:mb-0 [&_li]:mb-2 [&_ol>li]:list-decimal [&_ol]:mb-3 [&_ol]:pl-8 [&_p]:mb-3 [&_ul>li]:list-disc [&_ul]:mb-3 [&_ul]:pl-8"
            />
          </div>
        </div>
        <div className={`w-full ${isExpanded ? 'relative' : 'absolute bottom-0'}`}>
          <div className={`w-full h-28 bg-gradient-to-b from-transparent to-white ${isExpanded ? 'hidden' : ''}`}></div>
          <div className="flex flex-row justify-center bg-white">
            <button
                onClick={toggleExpansion}
                className="review-more-button flex-row text-xs"
                aria-label={`${isExpanded ? 'Collapse' : 'Expand'} product description`}
                type="button"
              >
                {isExpanded ? '- Read less' : '+ Read more'}
            </button>
          </div>
        </div>
      </div>

      {productDetailAccordionsSection || null}
    </div>
  );
}

ProductDetails.displayName = 'ProductDetails';
